module.exports = __webpack_public_path__ + "static/img/9.4b20af5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/9.png
// module id = XmDC
// module chunks = 0